import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MatDialog } from '@angular/material/dialog';
import { BookingDetailsComponent } from 'src/app/shared/components/booking-details/booking-details.component';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AddFutureBookingsComponent } from 'src/app/shared/components/add-future-bookings/add-future-bookings.component';

@Component({
  selector: 'sm-online-payments-report',
  templateUrl: './online-payments-report.component.html',
  styleUrls: ['./online-payments-report.component.scss']
})
export class OnlinePaymentsReportComponent implements OnInit, OnDestroy {
  selectedFrequency: any = 1
  // frequencyOfView: any
  selectedView: any = 'Data'
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
  pageTitle: string = 'Booking History' ;
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;
 
  fromDate:any = new Date();
  toDate:any = new Date();
  today: string = this.formatDate1(new Date())
  onlinePaymentReportData: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant('online_payment_report.column_headers.date'),
      columnProperty: "creation_time"
    },
    {
      columnName: 'Invoice Number',
      columnProperty: "inv_no"
    },
    {
      columnName: this.translateService.instant('online_payment_report.column_headers.amount'),
      columnProperty: "amount"
    },
    {
      columnName: this.translateService.instant('online_payment_report.column_headers.ref'),
      columnProperty: "razorpay_payment_id"
    },
    // {
    //   columnName: this.translateService.instant('online_payment_report.column_headers.status'),
    //   columnProperty: "payment_status"
    // },
    
  ];
  
  private _apiSubscription: Subscription;
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, private loaderservice: LoaderServiceService, public _modelRef: MatDialog, private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,private translateService: TranslateService) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_ALL_ENTITY_SERVICE_PAYMENTS_RESULT){
        this.onlinePaymentReportData = []
        if(true){
         this.onlinePaymentReportData = resData.result ? this.normalizeTransactionData(resData.result) : [] 
       
        }
        this.visible = true
        this.loaderservice.showLoader = false
      }
       if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_ALL_SERVICE_PAYMENT){
        this.onlinePaymentReportData = []
        if(true){

          this.onlinePaymentReportData = resData.result ? this.normalizeTransactionData(resData.result) : [] 
          console.log(this.onlinePaymentReportData);
          
        }
        this.visible = true
        this.loaderservice.showLoader = false
      }
    })
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
   }
   private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column,index) => {
      let data = [
        "date",
        "amount",
        "ref",
        "status",
      ]
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(`online_payment_report.column_headers.${data[index]}`);
    });
  }
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
  ngOnInit(): void {
   
 
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.fromDate.setDate(this.fromDate.getDate() - 30);
    this.fromDate = this.fromDate.toISOString().slice(0,10);
    this.toDate = this.toDate.toISOString().slice(0,10);
    this.loaderservice.showLoader = true
    this.visible = false
    if(this.isEntityForeign == '0'){
      this._apiService.getEntityAllServicePayments(this.entityHashId, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }
    else if(this.isEntityForeign == '1'){
       this._apiService.getInternationalEntityAllServicePayments(this.entityHashId, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }

  }
  search(){
       // Ensure date range is valid based on the selected frequency
       const fromDate = new Date(this.fromDate);
       const toDate = new Date(this.toDate);
   
       if (this.selectedFrequency === 1) { // Daily
         const maxRange = 90;
         const range = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 90 days.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       } else if (this.selectedFrequency === 2) { // Monthly
         const maxRange = 36;
         const range = (toDate.getMonth() - fromDate.getMonth() + (12 * (toDate.getFullYear() - fromDate.getFullYear())));
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 3 years.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       }
   
       //end
    if(this.selectedFrequency == 2){
      this.tableDisplayColumns = [
        {
          columnName: 'date',
          columnProperty: "creation_time"
        },
        {
          columnName: 'amount',
          columnProperty: "amount"
        },
        {
          columnName: 'payment ref id',
          columnProperty: "razorpay_payment_id"
        },
        {
          columnName: 'payment status',
          columnProperty: "payment_status"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getEntityAllServicePayments(this.entityHashId,this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }
    else{
      this.tableDisplayColumns = [
        {
          columnName: 'date',
          columnProperty: "creation_time"
        },
        {
          columnName: 'amount',
          columnProperty: "amount"
        },
        {
          columnName: 'payment ref id',
          columnProperty: "razorpay_payment_id"
        },
        {
          columnName: 'payment status',
          columnProperty: "payment_status"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getEntityAllServicePayments(this.entityHashId, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }
  }

  // changeFrequency(){
  //   if(this.selectedFrequency == 2){
  //     this.tableDisplayColumns = [
  //       {
  //         columnName: 'month',
  //         columnProperty: "month"
  //       },
  //       {
  //         columnName: 'total sales',
  //         columnProperty: "totalSales"
  //       },
  //       {
  //         columnName: 'home sales',
  //         columnProperty: "homeSales"
  //       },
  //       {
  //         columnName: 'shop sales',
  //         columnProperty: "shopSales"
  //       },
  //     ]
  //     this.loaderservice.showLoader = true
  //     this.visible = false
  //     this._apiService.getEntityAllServicePayments(this.entityHashId, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
  //   }
  //   else{
  //     this.tableDisplayColumns = [
  //       {
  //         columnName: 'date',
  //         columnProperty: "date"
  //       },
  //       {
  //         columnName: 'total sales',
  //         columnProperty: "totalSales"
  //       },
  //       {
  //         columnName: 'home sales',
  //         columnProperty: "homeSales"
  //       },
  //       {
  //         columnName: 'shop sales',
  //         columnProperty: "shopSales"
  //       },
  //     ]
  //     this.loaderservice.showLoader = true
  //     this.visible = false
  //     this._apiService.getEntityAllServicePayments(this.entityHashId, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
  //   }
  // }
 
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
 
  formatDate1(dateStr:Date) {

    let curdate = new Date(dateStr).toLocaleString('en-CA', {
      timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
  }).slice(0, 10);
      console.log(curdate);
      
      return curdate
  }

    normalizeTransactionData(dataArray: any[]): any[] {
  return dataArray.map(item => ({
    hash_id: item.hash_id || null,
    account_hash: item.account_hash || null,
    entity_hash: item.entity_hash || null,
    amount: typeof item.amount === 'number' ? item.currency_symbol +  item.amount.toFixed(2) : (item.currency_symbol +  (+item.amount).toFixed(2) || "0.00"),

    razorpay_payment_id: item.paypal_payment_capture_id || item.razorpay_payment_id || null,
    razorpay_order_id: item.paypal_order_id || item.razorpay_order_id || null,
    razorpay_signature: item.razorpay_signature || null,

    payment_status: typeof item.payment_status === 'number' ? item.payment_status.toString() : (item.payment_status || "0"),
    payment_mode: item.payment_mode || null,
    receipt: item.receipt || null,
    inv_no: item.inv_no || null,
    creation_time: item.creation_time || null,
    currency: item.currency || 'USD',
    currency_symbol: item.currency_symbol || '$',
  }));
}

}

